import sprite from '@trv-ebus/tds-icons/dist/assets/icons/functional/symbol-sprites.svg';
import _forEach from 'lodash/forEach';
import React from 'react';
import './styles.scss';

export default function Stepper({ steps }) {
    const stepperSteps = [];
    _forEach(steps, ({ progress, text }, index) => {
        let stepHtml;
        const stepTextClasses = ['step-text'];
        if (index === 0) {
            stepTextClasses.push('first');
        } else if (index === steps.length - 1) {
            stepTextClasses.push('last');
        }
        const stepTextClassName = stepTextClasses.join(' ');

        if (progress === 'current' || progress === 'incomplete') {
            stepHtml = (
                <div
                    key={'step' + index}
                    data-testid={'step' + index}
                    className={'step ' + progress}
                >
                    <div className="step-img"></div>
                    <div className={stepTextClassName}>{text}</div>
                </div>
            );
        } else if (progress === 'complete') {
            stepHtml = (
                <div
                    key={'step' + index}
                    data-testid={'step' + index}
                    className={'step ' + progress}
                >
                    <div>
                        <svg className="tds-icon-18" focusable="false">
                            <use xlinkHref={sprite + '#check-circle-1-12'} />
                        </svg>
                        <div className="complete-background"></div>
                    </div>
                    <div className={stepTextClassName}>{text}</div>
                </div>
            );
        } else {
            throw new Error('Invalid progress value set');
        }
        stepperSteps.push(stepHtml);

        const lastStep = steps.length - 1;
        if (index < lastStep) {
            stepperSteps.push(
                <div
                    key={'line' + index}
                    className={'line ' + (progress === 'complete' ? 'complete' : 'incomplete')}
                ></div>
            );
        }
    });

    return (
        <div data-testid="stepper-component" className="stepper-component">
            <div className="stepper">{stepperSteps}</div>
        </div>
    );
}
